import app from "@/main";
import {TaskDurum} from "../../../enum/TaskDurum";
import {DosyaBorclu} from "../../../uyap/DosyaBorclu";
import {DosyaBorclulariCevap} from "../../../uyap/DosyaBorclulari";
import {AvukatDosya} from "../../../uyap/AvukatDosya";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TakipSorguAlanlani} from "../TaskDataInterface/TakipSorgulaTaskDataInterface";
import {DosyaBorcluSSKCevap, SigortaDurumKod} from "@/plugins/uyap-plugin/uyap/DosyaBorcluSSK";
import {IKisiTumDVO, IKurumDVO} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";

export class TakipSorgulaTaskCevap {
    borclular: DosyaBorclulariCevap = [];
    dosya!: AvukatDosya;
    status: TaskDurum = TaskDurum.SIRADA;
    hataliSorguAlanlari: any[] = [];
    error: string = "";
}

export class TakipSorgulaTaskHandler extends AbstractTaskHandler {
    data: TakipSorgulaTaskCevap = new TakipSorgulaTaskCevap();

    async handle(task: ITask): Promise<ITask> {
        try {
            let dosya = await app.$uyap.DosyaBul().run(task);
            this.data.dosya = new AvukatDosya(dosya);
            // @ts-ignore
            let seciliBorcluSorgulamaAlanlari = task.data.sorguAlanlari.filter((item: TakipSorguAlanlani) => item.borcluyaOzel === true)
            try {
                if (this.borcluSorgulanacakMi(task.data.sorguAlanlari)) {
                    this.data.borclular = await app.$uyap.DosyaBorclulari().run({
                        dosyaId: dosya.dosyaId
                    });
                    await this.borcluAlanlariSorgula(seciliBorcluSorgulamaAlanlari, task.data.ucretliSorguyaDevamEt, task.data.barokarttanSorguBakiyesiYukle)
                }
            } catch (e) {
                this.data.error = e?.message ?? String(e);
                this.data.hataliSorguAlanlari = seciliBorcluSorgulamaAlanlari.map((alan: any) => ({
                    ...alan,
                    message: e?.message || "Borçlu bilgileri sorgulanamadı."
                }));
                this.data.status = TaskDurum.BITTI_EKSIK;
            }
            // @ts-ignore
            let seciliDosyaSorgulamaAlanlari = task.data.sorguAlanlari.filter((item: TakipSorguAlanlani) => item.borcluyaOzel === false)
            await this.dosyaAlanlariSorgula(seciliDosyaSorgulamaAlanlari);
            let icraproyaAktarilsinmi = task.data.sorguAlanlari.find((x: any) => x.name == "icraproaktar");
            if (icraproyaAktarilsinmi) {
                try {
                    await app.$http.post('/api/v1/task/takip-senkron', this.data);
                } catch (e) {
                    this.data.error = e?.message ?? String(e);
                }
            }

            task.status = TaskDurum.BITTI_BASARILI;
            if (this.data.status == TaskDurum.BITTI_EKSIK) {
                task.status = TaskDurum.BITTI_EKSIK;
            }
            let hataliAlanSayac: any = {};
            this.data.hataliSorguAlanlari.forEach((alan) => {
                let alanName = alan.name;
                if (hataliAlanSayac[alanName])
                    hataliAlanSayac[alanName]++;
                else
                    hataliAlanSayac[alanName] = 1;
            });
            if (Object.keys(hataliAlanSayac).length == task.data.sorguAlanlari.length) {
                task.status = TaskDurum.BITTI_HATALI;
            }
            task.response = this;
            return task;
        } catch (e) {
            task.status = TaskDurum.BITTI_HATALI;
            this.data.error = e?.message ?? String(e);
            task.description = e.message;
            throw new Error(e.message);
        }
    }

    async dosyaAlanlariSorgula(sorguAlanlari: any[]): Promise<void> {
        return new Promise(async (resolve) => {
            try {
                for (const alan of sorguAlanlari) {
                    await this.dosyaAlanSorgula(alan)
                }
                return resolve();
            } catch (e) {
                return resolve();
            }
        })
    }

    async borcluAlanlariSorgula(sorguAlanlari: any[], ucretliSorguyaDevamEt: boolean, barokarttanSorguBakiyesiYukle: boolean): Promise<void> {
        return new Promise(async (resolve) => {
            const normalAlanlar = sorguAlanlari.filter(a => a.name !== "mernis");
            const mernisAlan = sorguAlanlari.find(a => a.name === "mernis");
            const borcluyaOzelKritikHatalar = [
                "Borçlu hakkındaki icra takibi kesinleştirilmediği için sorgulama yapamazsınız. "
            ];
            const dosyaGeneliKritikHatalar = [
                "Bu işlemi bu dosya için gerçekleştiremezsiniz. Dosyada ALACAKLI vekili değilsiniz. "
            ];

            borcluLoop: for (let borclu of this.data.borclular) {
                for (const alan of normalAlanlar) {
                    try {
                        await this.borcluAlanSorgula(
                            borclu,
                            alan,
                            ucretliSorguyaDevamEt,
                            barokarttanSorguBakiyesiYukle
                        );
                    } catch (e) {
                        if (borcluyaOzelKritikHatalar.includes(e.message)) {
                            borclu.setBorcluErrorAllFields(e.message, ["mernis"]);
                            const mesaj = `${borclu.getAd()}: ${e.message}`;
                            const hataliSorguAlani = this.data.hataliSorguAlanlari.find(v => v.name === alan.name);
                            if (hataliSorguAlani) {
                                hataliSorguAlani.message += " " + mesaj;
                            } else {
                                this.data.hataliSorguAlanlari.push({...alan, message: mesaj});
                            }
                            continue borcluLoop;
                        } else if (dosyaGeneliKritikHatalar.includes(e.message)) {
                            for (let borcluH of this.data.borclular) {
                                borcluH.setBorcluErrorAllFields(e.message, ["mernis"]);
                            }
                            for (const alanData of normalAlanlar) {
                                let alanItem = {...alanData, message: e.message};
                                this.data.hataliSorguAlanlari.push(alanItem);
                            }
                            break borcluLoop;
                        } else {
                            let hataliMernisSorguAlani = this.data.hataliSorguAlanlari.find(v => v.name === alan.name)
                            const mesaj = `${borclu.getAd()}: ${e.message}`;
                            if (hataliMernisSorguAlani) {
                                hataliMernisSorguAlani.message += " " + mesaj;
                            } else {
                                this.data.hataliSorguAlanlari.push({
                                    ...alan,
                                    message: mesaj
                                });
                            }
                        }
                    }
                }
            }

            // Kritik hatalardan bağımsız mernis alanlarını sorgular
            if (mernisAlan) {
                for (let borclu of this.data.borclular) {
                    try {
                        await this.borcluAlanSorgula(
                            borclu,
                            mernisAlan,
                            ucretliSorguyaDevamEt,
                            barokarttanSorguBakiyesiYukle
                        );
                    } catch (e) {
                        let hataliMernisSorguAlani = this.data.hataliSorguAlanlari.find(v => v.name === "mernis")
                        const mesaj = `${borclu.getAd()}: ${e.message}`;
                        if (hataliMernisSorguAlani) {
                            hataliMernisSorguAlani.message += " " + mesaj;
                        } else {
                            this.data.hataliSorguAlanlari.push({
                                ...mernisAlan,
                                message: mesaj
                            });
                        }
                    }
                }
            }
            return resolve();
        });
    }

    async dosyaAlanSorgula(alan: any): Promise<void> {
        return new Promise(async (resolve) => {
            try {
                switch (alan.name) {
                    //Borclu olmayalnlar
                    case "taraflar":
                        await this.data.dosya.queryTaraflar();
                        break;
                    case "safahat":
                        await this.data.dosya.querySafahat();
                        break;
                    case "tahred":
                        await this.data.dosya.queryTahRed();
                        break;
                    case "tahredkalan":
                        await this.data.dosya.queryTahRed();
                        break;
                    case "evraklar":
                        await this.data.dosya.queryEvraklar();
                        break;
                    case "dosyadetay":
                        await this.data.dosya.queryDosyaBilgileri();
                        break;
                    case "dosyahesap":
                        await this.data.dosya.queryDosyaHesapBilgileri();
                        break;
                    case "barkod":
                        await this.data.dosya.queryBarkod();
                        break;
                    case "mtstebligat":
                        await this.data.dosya.queryMtsTebligat();
                        break;
                }
                return resolve();
            } catch (e) {
                alan.message = e.message;
                this.data.hataliSorguAlanlari.push(alan);
                this.data.status = TaskDurum.BITTI_EKSIK;
                return resolve();
            }
            //TODO "Bu işlemi bu dosya için gerçekleştiremezsiniz. Dosyada ALACAKLI vekili değilsiniz. "
        })
    }

    async borcluAlanSorgula(borclu: DosyaBorclu, alan: any, ucretliSorguyaDevamEt: boolean, barokarttanSorguBakiyesiYukle: boolean): Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                let dosyaId = this.data.dosya.dosya.dosyaId;
                switch (alan.name) {
                    case "sgkssk":
                        await borclu.queryBorcluSsk(dosyaId)
                        break;
                    case "egm":
                        await borclu.queryEgm(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
                        break;
                    case "egmmahrumiyet":
                        await borclu.queryEgmMahrumiyet(dosyaId)
                        break;
                    case "sskaktif":
                        await this.borcluSskAktifSorgula(borclu);
                        break;
                    case "mernis":
                        await borclu.queryBorcluMernis(dosyaId);
                        break;
                    case "mersis":
                        await borclu.queryBorcluMersis(dosyaId);
                        break;
                    case "sgkkamu":
                        await borclu.queryBorcluSgkKamu(dosyaId);
                        break;
                    case "gib":
                        await borclu.queryBorcluGib(dosyaId);
                        break;
                    case "sgkbagkur":
                        await borclu.queryBorcluSgkBagkur(dosyaId);
                        break;
                    case "dib":
                        await borclu.queryBorcluDib(dosyaId);
                        break;
                    case "sgkisyeri":
                        await borclu.queryBorcluSgkIsyeri(dosyaId);
                        break;
                    case "takbis":
                        await borclu.queryBorcluTakbis(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
                        break;
                    case "sgkhaciz":
                        await borclu.queryBorcluSgkHaciz(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
                        break;
                    case "iski":
                        await borclu.queryBorcluIski(dosyaId);
                        break;
                    case "icradosyakaydi":
                        await borclu.queryBorcluIcraDosyaKaydi(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
                        break;
                    case "gsm":
                        await borclu.queryBorcluGsm(dosyaId);
                        break;
                    case "postaceki":
                        await borclu.queryBorcluPostaCeki(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
                        break;
                    case "bankahesap":
                        await borclu.queryBorcluBankaBilgileri(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
                        break;
                    case "hisse":
                        await borclu.queryTasinmazHisse(dosyaId);
                        break;
                    case "takyidat":
                        await borclu.queryTasinmazTakyidat(dosyaId);
                        break;
                    case "bes":
                        await borclu.queryBorcluBes(dosyaId);
                        break;
                    case "sgkmossip":
                        await borclu.queryBorcluSgkMossip(dosyaId);
                        break;
                }
                return resolve();
            } catch (e) {
                if (e.message == "Borçlu hakkındaki icra takibi kesinleştirilmediği için sorgulama yapamazsınız. " ||
                    e.message == 'Bu işlemi bu dosya için gerçekleştiremezsiniz. Dosyada ALACAKLI vekili değilsiniz. ') {
                    return reject(e);
                }
                if (borclu.isKisi()) {
                    let borcluData = borclu.borcluBilgileri as IKisiTumDVO;
                    alan.message = borcluData.adi + " " + borcluData.soyadi + ": " + e.message;
                } else {
                    let borcluData = borclu.borcluBilgileri as IKurumDVO;
                    alan.message = borcluData.kurumAdi + ": " + e.message;
                }
                this.data.hataliSorguAlanlari.push(alan);
                this.data.status = TaskDurum.BITTI_EKSIK;
                return resolve();
            }
        })
    }

    async borcluSskAktifSorgula(borclu: DosyaBorclu): Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                await borclu.queryBorcluSsk(this.data.dosya.dosya.dosyaId)
                let ssk = borclu.ssk as DosyaBorcluSSKCevap;
                if (ssk.sorguSonucDVO?.sskBilgiDetay?.sgkIsyeriDVO?.sigortaliBilgi?.durumKod == SigortaDurumKod.AKTIF)
                    borclu.sskAktif = true;
                else
                    borclu.sskAktif = false
                return resolve();
            } catch (e) {
                return reject(e);
            }
        })

    }

    borcluSorgulanacakMi(sorguAlanlari: any[]): boolean {
        let flag = false;
        sorguAlanlari.forEach(alan => {
            if (alan.borcluyaOzel == true)
                flag = true;
        })
        return flag;
    }
}
